import { toSentenceCase } from "@iyk/string"
import { cva } from "@iyk/ui"
import { Link } from "@remix-run/react"
import {
  DISCORD_URL,
  INSTAGRAM_URL,
  PRIVACY_POLICY_URL,
  TERMS_AND_SERVICES_URL,
  TIKTOK_URL,
  TWITTER_URL,
  WARPCAST_URL,
} from "../../lib/constants.ts"
import { useLang } from "../../lib/lang/use-lang.ts"

export const Footer = ({ className }: FooterProps) => {
  const lang = useLang()

  return (
    <footer className={classForFooter({ className })}>
      <div className="flex flex-col md:flex-row md:gap-5">
        {footerLinks.map((link, idx) => (
          <Link
            key={idx}
            to={link.href}
            className={classNameForLink({
              className:
                "py-2 md:py-0 [&:not(:last-child)]:border-b border-b-gray-5 md:border-none",
            })}
            target="_blank"
            rel="noreferrer"
          >
            {link.text}
          </Link>
        ))}
      </div>

      <div className="flex items-center justify-between gap-5">
        <div className="flex items-center gap-5">
          <Link
            to={PRIVACY_POLICY_URL}
            className={classNameForLink()}
            target="_blank"
            rel="noreferrer"
          >
            {toSentenceCase(lang.terms.PRIVACY)}
          </Link>
          <Link
            to={TERMS_AND_SERVICES_URL}
            className={classNameForLink()}
            target="_blank"
            rel="noreferrer"
          >
            {toSentenceCase(lang.terms.TERMS)}
          </Link>
        </div>
        <Link to="https://iyk.app" className={classNameForLink()} target="_blank" rel="noreferrer">
          {toSentenceCase(lang.terms.POWERED_BY)} IYK*
        </Link>
      </div>
    </footer>
  )
}

const classForFooter = cva([
  "h-[var(--footer-height,0px)]",
  "flex flex-col justify-between md:gap-4 md:flex-row md:items-center",
  "px-4 py-4 md:py-0",
  "bg-background",
])

const classNameForLink = cva(["inline-block text-xs text-gray-11 hover:text-gray-12"])

const footerLinks = [
  {
    href: TWITTER_URL,
    text: "X (Twitter)",
  },
  {
    href: INSTAGRAM_URL,
    text: "Instagram",
  },
  {
    href: TIKTOK_URL,
    text: "TikTok",
  },
  {
    href: DISCORD_URL,
    text: "Discord",
  },
  {
    href: WARPCAST_URL,
    text: "Farcaster",
  },
]

type FooterProps = {
  className?: string
}
